export function SkeletonBlock({ className }: { className: string }) {
  return (
    <div className={`relative overflow-hidden bg-soft-grey/50 ${className}`}>
      <div
        className="absolute inset-0 -translate-x-full animate-[shimmer-slide_1.5s_infinite] bg-gradient-to-r from-transparent via-white/40 to-transparent"
      />
    </div>
  );
}